import {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  fetchCoverageAdequacy,
} from "../../services/riskFinancingApi";

export default function useCoverageAdequacy({
  enabled = false,
  simulations,
} = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] =
    useState(false);
  const [error, setError] =
    useState(null);

  const loadCoverageAdequacy =
    useCallback(async () => {
      if (
        !Number.isFinite(simulations) ||
        simulations <= 0
      ) {
        return null;
      }

      try {
        setLoading(true);
        setError(null);

        const result =
          await fetchCoverageAdequacy(
            simulations
          );

        setData(result);

        return result;
      } catch (requestError) {
        console.error(
          "Coverage Adequacy error:",
          requestError
        );

        setError(requestError);
        return null;
      } finally {
        setLoading(false);
      }
    }, [simulations]);

  useEffect(() => {
    if (!enabled) return;

    loadCoverageAdequacy();
  }, [
    enabled,
    loadCoverageAdequacy,
  ]);

  return {
    data,
    loading,
    error,
    refresh: loadCoverageAdequacy,
  };
}